import { render, staticRenderFns } from "./TransactionSplitSum.vue?vue&type=template&id=1a455d1e"
import script from "./TransactionSplitSum.vue?vue&type=script&lang=js"
export * from "./TransactionSplitSum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports